import { render, staticRenderFns } from "./Machine12.vue?vue&type=template&id=bf5dcdde&scoped=true&"
import script from "./Machine12.vue?vue&type=script&lang=js&"
export * from "./Machine12.vue?vue&type=script&lang=js&"
import style0 from "./Machine12.vue?vue&type=style&index=0&id=bf5dcdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5dcdde",
  null
  
)

export default component.exports